export default {
    videos: 'Videos',
    data_consumed: 'Datos consumidos (mb)',
    size: 'Tamaño (Mb)',
    lms_link: 'LMS Link',
    video: 'Video',
    no_file: 'No hay ningún archivo',
    text_upload_file: 'Empieza subiendo un nuevo archivo.',
    upload: 'Subir',
}